import React, { Component, createRef } from "react";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from "moment";
import * as XLSX from 'xlsx';
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class NearExpiryReport extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.inventoryServices = new InventoryServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            companyName: '',
            tableStatus: "",
            totalCount: 0,
            tableStatus: "",
            filterDetails: {
                materialType: 'Raw Material',
                days: ''
            },
            nearExpiryRecordsList: [],
            typeList: [
                { material: 'Raw Material' },
                { material: 'Packing Material' },
            ],
            validationRules: {
                days: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "days"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }

    componentDidMount() {
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.filterDetails
        details[name] = value;
        this.setState({ filterDetails: details })
    };

    handleDropdownChange = (e, name) => {
        const value = e.target.value;
        let details = this.state.filterDetails;
        details[name] = value;
        this.setState({ filterDetails: details });
    };

    getAllNearExpiryReport = () => {
        let isAllFieldsValidate = this.isAllFieldsValidate()
        if (isAllFieldsValidate) {
            this.setState({ tableStatus: "Loading..." })
            let request = this.state.filterDetails
            this.inventoryServices.getAllNearExpiryReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    if (response.responseData.length === 0) {
                        this.setState({ tableStatus: "No Record Found" })
                    } else {
                        this.setState({ tableStatus: "" })
                    }
                    let totalCount = response.responseData.length
                    this.setState({ nearExpiryRecordsList: response.responseData, totalCount: totalCount })
                } else {
                    this.setState({ tableStatus: "" })
                    this.SwalServices.Error(response.Message);
                }
            })
        }
    }

    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid
    }

    render() {
        return (
            <div className="nearExpiryReport-page reports-page">
                <div className="item-search !mb-2.5">
                    <div className="item-grp flex gap-2.5 w-[60%] !mb-3">
                        <div className="input-grp w-full">
                            <label>Months</label>
                            <input
                                className={` inputFocus ${this.state.validState?.error?.days ? "errorInput" : ""}`}
                                type="number"
                                id="days"
                                name="days"
                                autoComplete="off"
                                value={this.state.filterDetails.days}

                                onChange={(event) => this.handleChange(event, "days")}
                                style={{ width: "100%" }}
                            />
                            {/* <ValidationText
                                error={this.state.validState.error.days}
                            /> */}
                        </div>
                        <div className="input-grp w-full">
                            <label>Material Type</label>
                            <select
                                value={this.state.filterDetails.materialType}
                                onChange={(e) => this.handleDropdownChange(e, "materialType")}
                            >
                                {this.state.typeList.map((x, key) => (
                                    <option key={key} value={x.material}>
                                        {x.material}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="btn-grp">
                        <button class="add-btn" onClick={() => this.getAllNearExpiryReport()}>Search</button>
                        {this.state.totalCount > 0 ?
                            <button class="print-btn" onClick={() => printFunction()}>Print</button>
                            : null}
                    </div>



                </div>
                <div>
                    <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount ? this.state.totalCount : 0}</p>
                </div>
                <div class="item-listing">
                    <div className="hidden print-title">
                        <h4>Near Expiry Report</h4>
                        <p><span>Months remain:- {this.state.filterDetails.days}</span>,&nbsp;&nbsp;<span>Material type:- {this.state.filterDetails.materialType}</span></p>
                    </div>
                    <div class="itemList-table">
                        <div class="table-container" style={{ height: "calc(100vh - 200px)" }}>
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className="w-[4%]">Sr.</td>
                                        <td className="w-[22%]">Material Name</td>
                                        <td className="w-[22%]">Party Name</td>
                                        <td className="w-[8%]">Unit</td>
                                        <td className="w-[12%]">BatchNo</td>
                                        {/* <td style={{ width: "8%" }}>Days Remain</td> */}
                                        <td className="w-[12%]">Mfg Date</td>
                                        <td className="w-[12%]">Exp Date</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.nearExpiryRecordsList && this.state.nearExpiryRecordsList.length > 0 ?
                                        this.state.nearExpiryRecordsList.map((details, key) => (

                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>{details.rawMaterialId ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}</td>
                                                <td>{details.grnEntryPartyDetailId ? details.grnEntryPartyDetailId.partyId.partyName : ''}</td>
                                                <td>{details.rawMaterialId ? details.rawMaterialId.rmUOM : details.packageMaterialId.pmUOM}</td>
                                                <td>{details.batchNo}</td>
                                                {/* <td>{details.dayDifference ? details.dayDifference : 0}</td> */}
                                                <td>{details.mfgDate ? moment(details.mfgDate).format('MM/yyyy') : ''}</td>
                                                <td>{details.expDate ? moment(details.expDate).format('MM/yyyy') : ''}</td>
                                            </tr>

                                        )) : this.state.nearExpiryRecordsList &&
                                            this.state.nearExpiryRecordsList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.nearExpiryRecordsList &&
                                            this.state.nearExpiryRecordsList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Near Expiry Report</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            Months Remain: <strong>{this.state.filterDetails.days}</strong><br />
                                            Material Type: <strong>{this.state.filterDetails.materialType}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                      <div>
                                        <span className="info-label">Item Name:</span>
                                        <p className="info-value">Paracetamol</p>
                                      </div>
                                    </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "20%" }} />
                                <col style={{ width: "30%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Sr No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Material Name
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Party Name
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Unit
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Batch No
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Mfg Date
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Exp Date
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.nearExpiryRecordsList && this.state.nearExpiryRecordsList.length > 0 ?
                                    this.state.nearExpiryRecordsList.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {key + 1}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.rawMaterialId ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.grnEntryPartyDetailId ? details.grnEntryPartyDetailId.partyId.partyName : ''}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.rawMaterialId ? details.rawMaterialId.rmUOM : details.packageMaterialId.pmUOM}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.batchNo}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.mfgDate ? moment(details.mfgDate).format('MM/yyyy') : ''}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.expDate ? moment(details.expDate).format('MM/yyyy') : ''}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div >
        );
    }
}
export default NearExpiryReport;
